import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* getCustomerSegmentsFiltersWatcherSaga() {
  yield takeEvery(types.GET_CUSTOMER_SEGMENTS_FILTERS_API_CALL_REQUEST, workerSaga);
}

export function fetchData() {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/consumer/${client}/consumer-segment-filters/`;

  return axios.get(url)
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga(action) {
  try {
    const { isEdit } = action;
    const response = yield call(fetchData);
    if (response && response.status === 200) {
      const { data } = response;

      yield put({ type: types.GET_CUSTOMER_SEGMENTS_FILTERS_API_CALL_SUCCESS, data, isEdit });
    } else {
      yield put({ type: types.GET_CUSTOMER_SEGMENTS_FILTERS_API_CALL_FAILURE, error: 'error occured during get customer segments filters' });
    }
  } catch (error) {
    yield put({ type: types.GET_CUSTOMER_SEGMENTS_FILTERS_API_CALL_FAILURE, error });
  }
}
